<template><!-- 應用關聯影片 (參考 About-Video Rotate) -->
  <div v-if="application !== null">
    <h3 class="mb-5">Video Rotate</h3>
    <div class="h4 mb-5">為版面呈現正常, 建議上傳Preview Image</div>

    <!-- itemList -->
    <PageCollapse v-for="(item, i) in application.video_rotates" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Video {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <div>
          <!-- Title -->
          <label class="form-item d-flex pt-3">
            <h4 class="w-180px mt-5">Title</h4>
            <div class="flex-grow-1 mt-3">
              <v-text-field
              v-model="item.title"
              outlined
              dense
            ></v-text-field>
            </div>
          </label>
          <!-- upload type -->
          <div class="form-item d-flex pb-5 mt-5 align-center">
            <h4 class="w-180px mr-35px">UploadType</h4>
            <div class="flex-grow-1">
              <v-radio-group v-model="item.upload_type" row>
                <div
                  v-for="uploadType in [
                    {
                      label: '自電腦上傳影片',
                      value: 'file',
                    },
                    {
                      label: '來自Youtube/Youku連結',
                      value: 'link',
                    },
                  ]"
                  :key="uploadType.value"
                  class="w-50"
                >
                  <v-radio class="mr-01" :value="uploadType.value">
                    <template v-slot:label>
                      <div class="ink-01-emphasis--text w-202px">
                        {{ uploadType.label }}
                      </div>
                    </template>
                  </v-radio>
                </div>
              </v-radio-group>
            </div>
          </div>
        </div>

        <!-- upload type = 自電腦上傳影片 -->
        <div v-if="item.upload_type == 'file'">
          <div class="form-item d-flex px-5 pt-5 pb-5">
            <div class="w-200px">
              <h4 class="mb-10px">影片</h4>
              <div class="h5 ink-02-medium--text">
                影片支援格式：.mp4, .mov, .avi <br />
                檔案大小限制：&lt; 10 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <FileUploader
                v-model="item.url"
                dir="application"></FileUploader>
            </div>
          </div>
        </div>

        <!-- upload type = 來自Youtube/Youku連結 -->
        <div v-if="item.upload_type == 'link'">
          <label class="form-item d-flex">
            <h4 class="w-180px my-5 mr-6">影片連結</h4>
            <div class="flex-grow-1 my-3">
              <v-text-field
                v-model="item.url"
                prepend-inner-icon="mdi-link"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
        </div>

        <!-- img upload -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Preview Image</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.preview_image"
              dir="application"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add video -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加Video</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  components: {
    ImgUploader,
    PageCollapse,
    FileUploader,
  },
  computed: {
    ...mapState('application', ['application']),
  },
  created() {
    if (!this.application.video_rotates) {
      this.$set(this.application, 'video_rotates', []);
    }
  },
  methods: {
    addItem() {
      const template = {
        id: null,
        upload_type: 'file',
        url: '',
        preview_image: '',
        title: '',
      };
      this.application.video_rotates.push(template);
    },
    deleteItem(item) {
      const index = this.application.video_rotates
        .map((option) => option.id).indexOf(item.id);
      this.application.video_rotates.splice(index, 1);
    },
    downItem(item, i) {
      if (i === this.application.video_rotates.length - 1) {
        this.application.video_rotates.splice(i, 1);
        this.application.video_rotates.unshift(item);
        return;
      }
      this.application.video_rotates.splice(i, 1);
      this.application.video_rotates.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      if (i === 0) {
        this.application.video_rotates.splice(i, 1);
        this.application.video_rotates.push(item);
        return;
      }
      this.application.video_rotates.splice(i, 1);
      this.application.video_rotates.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
